import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

//should be used with useCallback
//example: const memoizedOnChange= useCallback(()=>{refetch()},[refetch]);
const useLanguageTracker = ({ onChange = () => {} }) => {
  const didMount = useRef(false);
  const [, i18n] = useTranslation();

  useEffect(() => {
    if (didMount.current) onChange();
    else didMount.current = true;
  }, [i18n.language, onChange]); // Only run this when the language changes.
};

export default useLanguageTracker;
